import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as urls from 'lib/urls'
import * as css from './banner.scss'

const OutOfAreaBanner = ({ country, showBabyListButton }) => {
  return (
    <div className={css.infoBanner}>
      <div className="container">
        <div className={css.flexRow}>
          <div className={css.middle}>
            Note: The Babylist store does not ship to&nbsp;
            {country}.
            {showBabyListButton && (
              <React.Fragment>
                &nbsp;To add items that can be shipped to you, install the{' '}
                <a
                  className="text-inverse text-underline"
                  href={urls.addItemsPath}
                >
                  Babylist Button
                </a>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

OutOfAreaBanner.propTypes = {
  country: PropTypes.string.isRequired,
  showBabyListButton: PropTypes.bool.isRequired,
}

export default OutOfAreaBanner
